import React from 'react'
import styles from './ActivityIndicator.module.css'
import styleNames from '../../utils/styleNames'

// it's spinkit
export const ActivityIndicator = () =>
  (
    <div className={styles['sk-fading-circle']}>
      <div className={styles['sk-circle']} />
      <div className={styleNames(styles, 'sk-circle2 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle3 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle4 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle5 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle6 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle7 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle8 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle9 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle10 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle11 sk-circle')} />
      <div className={styleNames(styles, 'sk-circle12 sk-circle')} />
    </div>
  )

export default ActivityIndicator
